import React, { ReactNode, Suspense } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import GlobalAbout from "./AboutUsSections/GlobalAbout";
import NavbarOther from "../components/NavbarOther";
import BlogHero from "./BlogSections/BlogHero";
import BlogSection from "./BlogSections/BlogSection";
const Footer = React.lazy(() => import("../components/Footer"));

interface SectionWrapperProps {
  children: ReactNode;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ children }) => {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <motion.section
      ref={ref}
      initial={{ y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      {children}
    </motion.section>
  );
};

const Blogs: React.FC = () => {
  return (
    <div className="about-us-container">

      {/* ✅ SEO TAGS GO HERE */}
      <Helmet>
        <title>Tellida Blog – Knowledge, Insights & Articles</title>
        <meta
          name="description"
          content="Explore articles, insights and updates from Tellida. Learn about outsourcing, recruitment, technology and more."
        />
        <link rel="canonical" href="https://tellida.com/blog" />
      </Helmet>

      {/* TOP NAV */}
      <NavbarOther />

      <SectionWrapper>
        <BlogHero />
      </SectionWrapper>

      <SectionWrapper>
        <BlogSection />
      </SectionWrapper>

      <SectionWrapper>
        <Footer />
      </SectionWrapper>
    </div>
  );
};

export default Blogs;
